import React from 'react';
import { AppContext, type AppContextType } from '../contexts/AppContext';

const useApp = () => React.useContext(AppContext) as AppContextType;

export default useApp;
